import Vue from "vue";
import * as MutationsType from "./mutationsType";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.SET_COLLECTION](state, payload) {
    state.collection = payload;
  },
  [MutationsType.SET_COLLECTIONS](state, payload) {
    state.collections = payload;
  },
  [MutationsType.ADD_COLLECTION](state, payload) {
    if (state.collections) state.collections.unshift(payload);
  },
  [MutationsType.UPDATE_COLLECTION](state, payload) {
    let ind = (state.collections || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.collections, ind, payload);
  },
  [MutationsType.DELETE_COLLECTION](state, payload) {
    let ind = (state.collections || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) state.collections.splice(ind, 1);
  },
};
